import afUsercentricsConsentArray from "../../../Assets/afUsercentric";

(function () {
    //Array that has infos about the consent regarding services
    let checkArray = [];
    let checkArrayLength = 0;

    //Page should reload in case the consent for some service(s) has changed
    window.addEventListener('load', function (event) {
        let thirdPartyServicesGlobal;
        if(localStorage.getItem("ucData")) {
            thirdPartyServicesGlobal = afUsercentricsConsentArray();
        }
        else {
            thirdPartyServicesGlobal = [{name: "Gehaltsvergleich", consent:{status:false}}];
        }
        const thirdPartyServicesLength = thirdPartyServicesGlobal.length;
        for (let i = 0; i < thirdPartyServicesLength; i++) {
            checkArray.push(thirdPartyServicesGlobal[i].consent.status);
        }
        checkArrayLength = checkArray.length;

        //Gehaltsvergleich check
        const placeholder = document.querySelectorAll('.af-gv-placeholder-data-protection')[0];
        if(thirdPartyServicesGlobal.filter(i => (i.name === "Gehaltsvergleich" && i.consent.status === true)).length > 0) {
            placeholder.parentElement.removeChild(placeholder);
            document.getElementById("gehatlsvergleich-script-1").src = "https://app.gehaltsreporter.de/js/embed-library-app/app.js";
            setTimeout(function() {document.getElementById("gehatlsvergleich-script-3").text = "gehaltsReporter('#c16867',{accountId:479,categories: [1,5,6,7,8,9,11,12,13,14,16,17]});";},500);
        }
        else {
            placeholder.addEventListener('click',function(){UC_UI.showFirstLayer();})
        }
    });
})();
